/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import type { IBvMenuItem } from 'volta/components/bv-menu';

import Component from '@glimmer/component';
import type { ComponentLike, ContentValue } from '@glint/template';

import type { BvBtnArgs } from '../bv-btn';
import type { BvCardFooterSignature } from './footer';
import type { BvCardHeaderSignature } from './header';
import type { BvCardSectionSignature } from './section';
import type { BvCardSubsectionSignature } from './subsection';

type ICardArgs = BvBtnArgs & IBvMenuItem;
interface ICardAction extends ICardArgs {
  content?: ContentValue;
  icon?: string;
}

interface BvCardSignature {
  Args: {
    embedded?: boolean;
    headerActions?: (ICardAction | undefined)[];
    headerAdditionalContent?: ContentValue | ComponentLike;
    onLightBg?: boolean;
    primaryFooterAction?: ICardAction;
    secondaryFooterActions?: (ICardAction | undefined)[];
    sectioned?: boolean;
    subdued?: boolean;
    subtitle?: ContentValue | ComponentLike;
    title?: ContentValue | ComponentLike;
  };
  Blocks: {
    default: [
      {
        Section: ComponentLike<BvCardSectionSignature>;
        Subsection: ComponentLike<BvCardSubsectionSignature>;
        Header: ComponentLike<BvCardHeaderSignature>;
        Footer: ComponentLike<BvCardFooterSignature>;
      }
    ];
    headerContent: [];
  };
  Element: HTMLDivElement;
}

export default class BvCardComponent extends Component<BvCardSignature> {
  get menuItems() {
    const { secondaryFooterActions } = this.args;
    if (secondaryFooterActions?.length && secondaryFooterActions.length > 1) {
      return secondaryFooterActions;
    }
    return [];
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BvCard: typeof BvCardComponent;
    'bv-card': typeof BvCardComponent;
  }
}
